(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('icd-10', {
            parent: 'entity',
            url: '/icd-10?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.icd10.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/icd-10/icd-10-s.html',
                    controller: 'Icd10Controller',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('icd10');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('icd-10-detail', {
            parent: 'entity',
            url: '/icd-10/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.icd10.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/icd-10/icd-10-detail.html',
                    controller: 'Icd10DetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('icd10');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Icd10', function($stateParams, Icd10) {
                    return Icd10.get({id : $stateParams.id});
                }]
            }
        })
        .state('icd-10.new', {
            parent: 'icd-10',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/icd-10/icd-10-dialog.html',
                    controller: 'Icd10DialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                title: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('icd-10', null, { reload: true });
                }, function() {
                    $state.go('icd-10');
                });
            }]
        })
        .state('icd-10.edit', {
            parent: 'icd-10',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/icd-10/icd-10-dialog.html',
                    controller: 'Icd10DialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Icd10', function(Icd10) {
                            return Icd10.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('icd-10', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('icd-10.delete', {
            parent: 'icd-10',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/icd-10/icd-10-delete-dialog.html',
                    controller: 'Icd10DeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Icd10', function(Icd10) {
                            return Icd10.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('icd-10', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
